import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartContactForm',
  setup(__props) {

const { tc } = useI18n();

const form: HTMLFormElement = ref() as any;

let formData = {
	firstName: '',
	lastName: '',
	email: '',
	topic: '',
	message: '',
};
let formError = '';
let success = false;

async function handleSubmit(e: Event) {
	try {
		const emailBody = `Dear Sir/Madam,%0D%0A%0D%0A${formData.message}%0D%0A%0D%0AYou can contact me by:%0D%0AEmail: ${formData.email}%0D%0A%0D%0AYours faithfully,%0D%0A${formData.firstName} ${formData.lastName}`;
		window.location.href = `mailto:partner@justwatch.com?subject=${formData.topic}&body=${emailBody}`;
	} catch (err) {
		formError = 'Something went wrong. Please try again.';
	} finally {
		formData.firstName = '';
		formData.lastName = '';
		formData.email = '';
		formData.topic = '';
		formData.message = '';
		success = true;
		e.preventDefault();
	}
}

return { __sfc: true,tc, form, formData, formError, success, handleSubmit }
}

})